import './git.css'

export default function App(){
    return(
        <div className="app">
            this is app
            <h1>上传远程</h1>
            <div className="box"></div>
            <div className="box">我是第二个div</div>
        </div>
    )
}